export default "__VITE_ASSET__fb8d6dc2__"